import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontSelectorComponent } from './font-selector/font-selector.component';
import { ButtonComponent } from '@ppl/ui';
import { environment } from '../../../../../environments/environment';
import { GoogleTranslateComponent } from '../../../../google-translate/google-translate.component';

@Component({
  selector: 'ppl-footer',
  standalone: true,
  imports: [CommonModule, FontSelectorComponent, ButtonComponent, GoogleTranslateComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent implements OnInit, AfterViewInit, OnDestroy {
  isDarkTheme = false;
  isDevelopment = !environment.production;
  private resizeObserver?: ResizeObserver;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngOnInit() {
    // Check if dark theme is already applied
    this.isDarkTheme = document.body.classList.contains('dark-theme');
  }

  ngAfterViewInit() {
    this.updateFooterOffset();

    const footerElement = this.elementRef.nativeElement.querySelector('.footer');
    if (!footerElement) {
      return;
    }

    this.resizeObserver = new ResizeObserver(() => {
      this.updateFooterOffset();
    });
    this.resizeObserver.observe(footerElement);
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
  }

  private updateFooterOffset() {
    const footerElement = this.elementRef.nativeElement.querySelector('.footer') as HTMLElement | null;
    const footerHeight = footerElement?.offsetHeight ?? 0;
    document.documentElement.style.setProperty('--ppl-footer-offset', `${footerHeight}px`);
  }

  toggleDarkTheme() {
    this.isDarkTheme = !this.isDarkTheme;
    const body = document.body;
    if (this.isDarkTheme) {
      body.classList.add('dark-theme');
      localStorage.setItem('theme', 'dark');
    } else {
      body.classList.remove('dark-theme');
      localStorage.setItem('theme', 'light');
    }
  }
}
